export default __webpack_public_path__ + "static/media/search-small.248f8ba7.svg";